export default "__VITE_ASSET__dZeUb7kx__"